export const ADD_CONTACT = 'contacts/addContact'
export const REMOVE_CONTACT = 'contacts/removeContact'
export const REPLACE_CONTACTS = 'contacts/replaceContacts'
export const ADD_CONTACTS_TO_LIST = 'contacts/addContactsToList'

const obj = {
  ADD_CONTACT,
  REMOVE_CONTACT,
  REPLACE_CONTACTS,
  ADD_CONTACTS_TO_LIST,
}

export default obj
